export const maskPhone = phone => {
  if (!phone) return '';
  const totalLength = phone.length;
  const hiddenPart = '****';
  const visibleLength = Math.floor((totalLength - hiddenPart.length) / 2);
  const visibleStart = phone.slice(0, visibleLength);
  const visibleEnd = phone.slice(-visibleLength);
  return `${visibleStart}${hiddenPart}${visibleEnd}`;
};
